export const FEATURE_FLAG = 'EnableInlineHelp';
export const TEXT_TYPE = 'text';
export const KEY_TERM_TYPE = 'keyTerm';
export const IMAGE_TYPE = 'image';
export const VIDEO_TYPE = 'video';
export const LINK_TYPE = 'link';
export const HEADER = 'header';
export const OVERVIEW = 'overview';
export const KEY_HEADING = 'keyTerminology';
export const FOOTER = 'footer';

export default FEATURE_FLAG;